import React, { useCallback, useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import {
    showModal,
    webSerialConnect,
    webSerialDisconnect,
    deviceDetails,
    deviceMismatch,
    setSelectionBackRoute,
} from '../../redux/actions/index'
import renderImage from '../../source/importImg'
import DeviceSelectStyle from './DeviceSelect.module.css'

import DialogModal from '../ReusableComponents/DialogModal/DialogModal'
import DeviceMismatchDialog from '../ReusableComponents/FirmwareUpdateDialog/DeviceMismatchDialog'
import FirmwareAssetsUpdateModal from '../ReusableComponents/FirmwareAssetsUpdateModal/FirmwareAssetsUpdateModal'
import WebAgentDialog from '../ReusableComponents/WebAgentDialog/WebAgentDialog'
import AssetUpdateDialog from '../ReusableComponents/AssetUpdateDialog/AssetUpdateDialog'
import FirmwareUpdateDialog from '../ReusableComponents/FirmwareUpdateDialog/FirmwareUpdateDialog'
import packageJson from '../../../package.json'
import {
    getVersionArguments,
    getVersionObjNameKey,
    getRequiredFirmwareMin,
    getVersionSeries,
} from '../../utils/verionControl'
import { connectSerialDeviceInitial } from '../WebSerialConnection/SerialUSBConnect'
import { Transport } from '../FirmwareJS/webserial'
import { ESPLoader } from '../FirmwareJS/ESPLoader'
import CryptoJS from 'crypto-js'
import cacheAssets from '../../utils/cacheAssets'
import { fetchVersion } from './FlashFiles'
import { languageWords } from '../../utils/langaugeSupport'
import {
    checkFirmwareVersion,
    fetchFirmwareFiles,
} from '../../utils/firmwareUpdateFlow'
import { downloadWebAgent } from '../../utils/manualUpdateHelpers'
// import { ifAiTranDataDelete } from '../../utils/utils'
import {
    getAppName,
    getBrandDeviceName,
    getPeeCeeVariantLabel,
} from '../../hooks/useBrandConfig'
import { SERIAL_PORT_FILTERS } from '../../utils/usbDeviceIds'
const ENDPOINT = 'localhost:3008'
//let socket = socketIOClient("http://localhost:3008");

const getPlodeVersion = (connectedDevice) => {
    if (connectedDevice === 'Ace')
        return packageJson['plode-versions']['plode-pc']
    // else if (connectedDevice === "Humanoid")
    else return packageJson['plode-versions']['plode-humanoid']
}

const DeviceSelect = (props) => {
    // Prevent browser back button
    window.history.forward()

    const [variDevice, setVariDevice] = useState(false)
    const [isDeviceMismatch, setIsDeviceMismatch] = useState(false)
    const [slideDirection, setSlideDirection] = useState(
        sessionStorage.getItem('slideDirection')
    )
    const [showDialogs, setShowDialogs] = useState({
        showDialog: false,
        showConnecting: false,
        showReconnectDialog: false,
        showBootModeDialog: false,
        text: '',
        progress: null,
    })

    const isDeviceMismatchRef = useRef(isDeviceMismatch)
    const socketDataRef = useRef(props.socketData)
    const timeoutRef = useRef(null)
    const webAgentResolveRef = useRef(null)
    const assetUpdateResolveRef = useRef(null)
    const firmwareUpdateResolveRef = useRef(null)
    const isMountedRef = useRef(true)
    const prevAgentConnectedRef = useRef(props.socketData?.isAgentConnected)
    const [isHelp, setHelp] = useState(false)
    const [showCustomFirmwareDialog, setShowCustomFirmwareDialog] =
        useState(false)
    const [firmwareDialogType, setFirmwareDialogType] = useState('custom')
    const [pendingAutoFlash, setPendingAutoFlash] = useState(null)

    let history = useHistory()

    useEffect(() => {
        socketDataRef.current = props.socketData
    }, [props.socketData])

    const getLatestSocket = () => socketDataRef.current

    useEffect(() => {
        isDeviceMismatchRef.current = isDeviceMismatch
    }, [isDeviceMismatch])

    // Redirect to Selection if already connected (skip if firmware flash pending)
    useEffect(() => {
        if (
            props.webserialPort.isConnected &&
            sessionStorage.getItem('connectedDevice') &&
            variDevice &&
            !localStorage.getItem('firmwareUpdateConsent') &&
            !localStorage.getItem('microPythonUpdateConsent') &&
            !sessionStorage.getItem('pendingFirmwareUpdate') &&
            !sessionStorage.getItem('firmwareUpdateInProgress') &&
            !pendingAutoFlash
        ) {
            history.push('/Selection')
        }
    })

    // Cleanup session on mount
    useEffect(() => {
        sessionStorage.setItem('uploading', false)
        // Preserve sessionStorage when going back to KitMenu, as it needs device info
        // Only clear if coming from KitSelection or other routes where device isn't set yet
        if (
            !props.webserialPort.isConnected &&
            props.selectionBackRoute !== '/kitMenu'
        ) {
            sessionStorage.removeItem('deviceVersion')
            sessionStorage.removeItem('connectedDevice')
            sessionStorage.removeItem('manualConnection')
            sessionStorage.removeItem('matchedDevices')
            sessionStorage.removeItem('user')
            sessionStorage.removeItem('webSerialPortList')
            sessionStorage.removeItem('isPlay')
        }
    }, [])

    // Auto-trigger firmware flash if user gave consent from Selection/VisualProgram
    useEffect(() => {
        if (localStorage.getItem('firmwareUpdateConsent') === 'true') {
            localStorage.removeItem('firmwareUpdateConsent')
            setPendingAutoFlash('custom')
        }
        if (localStorage.getItem('microPythonUpdateConsent') === 'true') {
            localStorage.removeItem('microPythonUpdateConsent')
            setPendingAutoFlash('micropython')
        }
    }, [])

    useEffect(() => {
        const pending = sessionStorage.getItem('pendingFirmwareUpdate')
        if (!pending) return
        sessionStorage.removeItem('pendingFirmwareUpdate')
        try {
            const firmwareCheck = JSON.parse(pending)
            if (firmwareCheck?.firmwarePath) {
                performFirmwareUpdate(firmwareCheck)
            }
        } catch (error) {
            console.error('Invalid pending firmware update payload:', error)
        }
    }, [])

    // Auto-connection logic
    useEffect(() => {
        sessionStorage.removeItem('connectText')
        sessionStorage.removeItem('verPopUpCount')
        if (JSON.parse(sessionStorage.getItem('autoCunnection'))) {
            if (props.webserialPort.isConnected) setVariDevice(true)
            sessionStorage.setItem('autoCunnection', 'false')
        } else {
            setVariDevice(false)
        }
    }, [props.webserialPort.isConnected])

    useEffect(() => {
        isMountedRef.current = true
        return () => {
            isMountedRef.current = false
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            if (webAgentResolveRef.current) {
                webAgentResolveRef.current(false)
                webAgentResolveRef.current = null
            }
        }
    }, [])

    // Monitor agent connection
    useEffect(() => {
        const wasDisconnected = !prevAgentConnectedRef.current
        const isNowConnected = props.socketData?.isAgentConnected

        if (
            wasDisconnected &&
            isNowConnected &&
            props.webAgentDialog?.isInstalling
        ) {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            timeoutRef.current = setTimeout(() => {
                if (isMountedRef.current && webAgentResolveRef.current) {
                    props.hideWebAgentDialog()
                    webAgentResolveRef.current(true)
                    webAgentResolveRef.current = null
                }
            }, 2000)
        }
        prevAgentConnectedRef.current = isNowConnected
    }, [props.socketData?.isAgentConnected, props.webAgentDialog?.isInstalling])

    const goBackUrl = () => {
        setSlideDirection(true)
        sessionStorage.setItem('slideDirection', true)
        if (props.selectionBackRoute !== '/kitMenu') {
            sessionStorage.removeItem('allowedDevice')
        }
        history.push(props.selectionBackRoute)
    }

    const handleHelpBtn = () => {
        setHelp(!isHelp)
    }

    const handleFirmwareProgress = (progress) => {
        props.setFirmwareAssetsUpdateProgress({
            isOpen: progress.stage !== 'complete',
            stage: progress.stage,
            message: progress.message,
            percent: progress.percent || null,
        })

        if (progress.stage === 'complete') {
            if (timeoutRef.current) clearTimeout(timeoutRef.current)
            timeoutRef.current = setTimeout(() => {
                props.setFirmwareAssetsUpdateProgress({
                    isOpen: false,
                    stage: '',
                    message: '',
                    percent: null,
                })
                if (props.webAgentDialog?.isOpen) props.hideWebAgentDialog()
            }, 3000)
        }
    }

    const handleCloseModal = () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current)
        props.setFirmwareAssetsUpdateProgress({
            isOpen: false,
            stage: '',
            message: '',
            percent: null,
        })
    }

    // --- Web Agent Handlers ---
    const handleWebAgentRequired = () => {
        return new Promise((resolve) => {
            if (!isMountedRef.current) {
                resolve(false)
                return
            }
            props.setFirmwareAssetsUpdateProgress({ isOpen: false })
            setShowDialogs((prev) => ({
                ...prev,
                showConnecting: false,
                text: '',
            }))
            webAgentResolveRef.current = resolve
            props.showWebAgentDialog()
        })
    }

    const handleWebAgentInstall = async () => {
        props.setWebAgentInstalling()
        await downloadWebAgent()
    }

    const handleWebAgentCancel = () => {
        if (!isMountedRef.current) return
        props.hideWebAgentDialog()
        props.setUserIgnoredWebAgent()
        if (webAgentResolveRef.current) {
            webAgentResolveRef.current('cancel')
            webAgentResolveRef.current = null
        }
    }

    const handleWebAgentStop = () => {
        if (!isMountedRef.current) return
        props.hideWebAgentDialog()
        props.setUserIgnoredWebAgent()
        if (webAgentResolveRef.current) {
            webAgentResolveRef.current(false)
            webAgentResolveRef.current = null
        }
    }

    // --- Asset Update Handlers ---
    const handleAssetUpdateConfirm = () => {
        return new Promise((resolve) => {
            if (!isMountedRef.current) {
                resolve(false)
                return
            }
            if (props.webAgentDialog?.isOpen) props.hideWebAgentDialog()
            setShowDialogs((prev) => ({
                ...prev,
                showConnecting: false,
                text: '',
            }))
            assetUpdateResolveRef.current = resolve
            props.showAssetUpdateDialog()
        })
    }

    const handleAssetUpdateInstall = () => {
        if (!isMountedRef.current) return
        props.hideAssetUpdateDialog()
        if (assetUpdateResolveRef.current) {
            assetUpdateResolveRef.current(true)
            assetUpdateResolveRef.current = null
        }
    }

    const handleAssetUpdateSkip = () => {
        if (!isMountedRef.current) return
        props.hideAssetUpdateDialog()
        props.setUserIgnoredAssetUpdate()
        if (assetUpdateResolveRef.current) {
            assetUpdateResolveRef.current(false)
            assetUpdateResolveRef.current = null
        }
    }

    // --- Firmware Update Handlers ---
    const handleFirmwareUpdateRequired = (firmwareCheck) => {
        return new Promise((resolve) => {
            if (!isMountedRef.current) {
                resolve(false)
                return
            }
            props.showFirmwareUpdateDialog({
                currentVersion: firmwareCheck.currentVersion,
                latestVersion: firmwareCheck.latestVersion,
                deviceName: firmwareCheck.deviceName,
                firmwareCheck: firmwareCheck,
            })
            setShowDialogs((prev) => ({
                ...prev,
                showConnecting: false,
                text: '',
            }))
            firmwareUpdateResolveRef.current = resolve
        })
    }

    const handleFirmwareUpdate = async () => {
        if (!isMountedRef.current) return
        const firmwareCheck = props.firmwareUpdateDialog.firmwareCheck
        props.hideFirmwareUpdateDialog()
        setShowDialogs({ showConnecting: false, showDialog: false, text: '' })

        if (firmwareUpdateResolveRef.current) {
            firmwareUpdateResolveRef.current(true)
            firmwareUpdateResolveRef.current = null
        }

        await performFirmwareUpdate(firmwareCheck)
    }

    // --- CORE FIRMWARE UPDATE LOGIC ---
    const performFirmwareUpdate = async (firmwareCheck) => {
        sessionStorage.setItem('firmwareUpdateInProgress', 'true')

        try {
            // 0. Ensure worker releases the serial port before ESPLoader takes over
            if (props.worker) {
                try {
                    props.worker.postMessage({ type: 'disconnected' })
                    await new Promise((r) => setTimeout(r, 500))
                } catch (e) {
                    console.warn('Worker disconnect warning:', e)
                }
            }

            // 1. Request Port directly
            setShowDialogs({
                showConnecting: true,
                text: 'Please select your device to start the firmware update...',
            })

            let device
            try {
                const pairedPorts = await navigator.serial.getPorts({
                    filters: SERIAL_PORT_FILTERS,
                })
                device =
                    pairedPorts[0] ||
                    (await navigator.serial.requestPort({
                        filters: SERIAL_PORT_FILTERS,
                    }))
            } catch (portError) {
                sessionStorage.removeItem('firmwareUpdateInProgress')
                setShowDialogs({
                    showConnecting: false,
                    showReconnectDialog: true,
                    text: 'Device selection was cancelled.\n\nWould you like to try again?',
                    reconnectOptions: [
                        {
                            text: 'Try Again',
                            do: () => {
                                setShowDialogs({
                                    showReconnectDialog: false,
                                    showConnecting: false,
                                    text: '',
                                })
                                performFirmwareUpdate(firmwareCheck)
                            },
                        },
                        {
                            text: 'Cancel',
                            do: () => {
                                setShowDialogs({
                                    showReconnectDialog: false,
                                    showConnecting: false,
                                    text: '',
                                })
                            },
                        },
                    ],
                })
                return
            }

            // 2. Pre-Flight / Chip Detection
            setShowDialogs({
                showConnecting: true,
                text: 'Preparing device (Resetting)...',
            })

            // Ensure port is closed initially to allow ESPLoader to take control
            if (device.readable || device.writable) {
                try {
                    console.log('Port appears open, forcing close...')
                    await device.close()
                } catch (e) {
                    console.warn('Close warning:', e)
                }
                await new Promise((r) => setTimeout(r, 300))
            }
            await new Promise((r) => setTimeout(r, 200))
            const transport = new Transport(device)
            const esploader = new ESPLoader(transport, 460800)

            setShowDialogs({
                showConnecting: true,
                text: 'Connecting to device...',
                // text: 'Connecting to device...\nIf this takes too long, try holding the BOOT button on the device.',
            })

            let chipId
            try {
                chipId = await esploader.main_fn()
            } catch (syncError) {
                console.error('ESPLoader sync failed:', syncError)
                try {
                    await transport.disconnect()
                } catch (e) {}
                // Clear immediately, not just on "Cancel" below — otherwise
                // leaving this dialog any other way (reload, navigating
                // away) leaves the flag stuck and silently blocks the next
                // Scan Device click (connectSerialDeviceInitial no-ops
                // while it's set).
                sessionStorage.removeItem('firmwareUpdateInProgress')
                setShowDialogs({
                    showConnecting: false,
                    showReconnectDialog: true,
                    text: 'Could not connect to bootloader.\n\nPlease try again:\n1. Disconnect the device\n2. Hold the BOOT button\n3. Reconnect via USB\n4. Release the BOOT button\n5. Click "Try Again"',
                    reconnectOptions: [
                        {
                            text: 'Try Again',
                            do: () => {
                                setShowDialogs({
                                    showReconnectDialog: false,
                                    showConnecting: false,
                                    text: '',
                                })
                                performFirmwareUpdate(firmwareCheck)
                            },
                        },
                        {
                            text: 'Cancel',
                            do: () => {
                                setShowDialogs({
                                    showReconnectDialog: false,
                                    showConnecting: false,
                                    text: '',
                                })
                                sessionStorage.removeItem(
                                    'firmwareUpdateInProgress'
                                )
                            },
                        },
                    ],
                })
                return
            }
            console.log(`Target Chip ID: ${chipId}`)

            // 3. Download Firmware Files via changelog
            setShowDialogs({
                showConnecting: true,
                text: 'Downloading firmware...',
            })
            const flashFilesData = await fetchFirmwareFiles(firmwareCheck)

            // 4. Erase & Flash
            setShowDialogs({
                showConnecting: true,
                text: 'Erasing chip (Do not disconnect)...',
            })
            await esploader.erase_flash()

            setShowDialogs({
                showConnecting: true,
                text: 'Writing firmware...',
                progress: 0,
            })
            await esploader.write_flash({
                fileArray: flashFilesData,
                flash_size: 'keep',
                reportProgress: (fileIndex, written, total) => {
                    const progress = Math.round((written / total) * 100)
                    setShowDialogs({
                        showConnecting: true,
                        text: 'Writing firmware...',
                        progress,
                    })
                },
                calculateMD5Hash: (image) =>
                    CryptoJS.MD5(CryptoJS.enc.Latin1.parse(image)),
            })

            // 6. Cleanup & Reset
            await transport.disconnect()

            // 7. PERFORM HARD RESET (Boot new firmware)
            console.log('Firmware written. Resetting device...')
            setShowDialogs({
                showConnecting: true,
                text: 'Resetting device...',
            })
            if (!device.readable) {
                console.log('Port is closed. Re-opening for Hard Reset...')
                // We re-open at 115200 (standard), though baud rate doesn't affect signal toggling much
                await transport.connect({ baud: 115200 })
            }
            // Using transport to manually toggle signals for a strict reset
            // DTR=0, RTS=1 (Reset held)
            await transport.setDTR(false)
            await transport.setRTS(true)
            await new Promise((r) => setTimeout(r, 100))

            // DTR=0, RTS=0 (Release Reset -> Boot App)
            await transport.setRTS(false)
            await transport.setDTR(false)

            console.log('Device reset signal sent.')

            // Optional: Wait a moment for boot
            await new Promise((r) => setTimeout(r, 1000))

            // 8. Cleanup
            await transport.disconnect()

            // 9. Success — clear flags and redirect
            localStorage.removeItem('customCodeFlashed')
            localStorage.removeItem('microPythonFlashed')
            sessionStorage.removeItem('firmwareUpdateInProgress')
            sessionStorage.removeItem('microPython')
            props.clearIgnoredFirmware()

            const deviceNameKeyMap = {
                playcomputer: 'Ace',
                zing: 'Humanoid',
                crawlee: 'Hexapod',
                roboki: 'Roboki',
                klaw: 'Klaw',
            }
            const flashedDeviceName =
                deviceNameKeyMap[firmwareCheck.deviceName.toLowerCase()] ||
                'Ace'
            const flashedVersion = firmwareCheck.latestVersion || '1.0'

            // NOW update localStorage with the device we actually just flashed
            localStorage.setItem('lastConnectedDevice', flashedDeviceName)
            localStorage.setItem(
                'lastConnectedDeviceVersion',
                flashedVersion?.split('.')?.slice(0, 2)?.join('.') || '1.0'
            )

            setShowDialogs({
                showConnecting: false,
                showReconnectDialog: true,
                text: 'Firmware updated successfully!\n\nPlease disconnect and reconnect the device.',
                reconnectOptions: [
                    {
                        text: 'OK',
                        do: () => {
                            setShowDialogs({
                                showReconnectDialog: false,
                                showConnecting: false,
                                text: '',
                            })
                            const lastDevice =
                                localStorage.getItem('lastConnectedDevice') ||
                                'Ace'
                            const fullVersion =
                                firmwareCheck.latestVersion ||
                                localStorage.getItem(
                                    'lastConnectedDeviceVersion'
                                ) ||
                                '1.0'
                            sessionStorage.setItem(
                                'connectedDevice',
                                lastDevice
                            )
                            sessionStorage.setItem('deviceVersion', fullVersion)
                            props.deviceDetails({
                                connectedDevice: lastDevice,
                                deviceVersion: fullVersion,
                            })
                            sessionStorage.setItem('autoCunnection', 'true')
                            history.push('/Selection')
                        },
                    },
                ],
            })
        } catch (error) {
            console.error('Firmware Update Error:', error)
            sessionStorage.removeItem('firmwareUpdateInProgress')
            setShowDialogs({ showConnecting: false, text: '' })
            alert(`Update Failed: ${error.message}`)
        }
    }

    const handleFirmwareUpdateSkip = () => {
        if (!isMountedRef.current) return
        const currentDevice = sessionStorage.getItem('connectedDevice')
        const currentVersion = sessionStorage.getItem('deviceVersion')
        const firmwareKey = `${currentDevice}:${currentVersion}`
        props.setUserIgnoredFirmwareUpdate(firmwareKey)
        props.hideFirmwareUpdateDialog()
        if (firmwareUpdateResolveRef.current) {
            firmwareUpdateResolveRef.current(false)
            firmwareUpdateResolveRef.current = null
        }
    }

    const handleFirmwareUpdateClose = () => {
        if (!isMountedRef.current) return
        props.hideFirmwareUpdateDialog()
        if (props.worker) props.worker.postMessage({ type: 'disconnected' })
        props.webSerialDisconnect()
        if (firmwareUpdateResolveRef.current) {
            firmwareUpdateResolveRef.current(false)
            firmwareUpdateResolveRef.current = null
        }
    }

    const handleCustomFirmwareContinue = () => {
        setShowCustomFirmwareDialog(false)
        if (firmwareDialogType === 'micropython') {
            setVariDevice(true)
            return
        }
        if (firmwareDialogType === 'unknown') {
            localStorage.setItem('customCodeFlashed', 'true')
        }
        const allowedDevice = sessionStorage.getItem('allowedDevice') || 'Ace'
        const deviceId = allowedDevice.includes('Ace') ? 'Ace' : allowedDevice
        sessionStorage.setItem('connectedDevice', deviceId)
        const versionArg = getVersionArguments[allowedDevice]
        const deviceName = versionArg?.deviceName || 'Playcomputer'
        const baseVersion = versionArg?.version || '1.0'
        sessionStorage.setItem('deviceVersion', baseVersion + '.0')
        localStorage.setItem('lastConnectedDevice', deviceId)
        // localStorage.setItem('lastConnectedDeviceVersion', baseVersion)
        props.deviceDetails({
            connectedDevice: deviceId,
            deviceVersion: baseVersion + '.0',
        })
        history.push('/Selection')
    }

    const handleCustomFirmwareFlash = async () => {
        setShowCustomFirmwareDialog(false)
        const lastDevice =
            localStorage.getItem('lastConnectedDevice') === 'Ace'
                ? 'playcomputer'
                : localStorage.getItem('lastConnectedDevice') === 'Humanoid'
                  ? 'zing'
                  : localStorage.getItem('lastConnectedDevice') || ''
        const lastVersion =
            localStorage.getItem('lastConnectedDeviceVersion') || '1.0'
        const deviceNameKey = getVersionObjNameKey(lastDevice)
        const dummyCurrentVersion = lastVersion + '.0'

        try {
            if (!sessionStorage.getItem('versionData')) {
                try {
                    const versionResponse = await fetch(
                        'https://embedded.plode.org/version-list'
                    )
                    const versionData = await versionResponse.json()
                    sessionStorage.setItem(
                        'versionData',
                        JSON.stringify(versionData)
                    )
                } catch (e) {
                    console.error('Failed to fetch version data:', e)
                }
            }

            const firmwareCheck = await checkFirmwareVersion(
                deviceNameKey,
                dummyCurrentVersion
            )
            if (firmwareCheck && firmwareCheck.firmwarePath) {
                firmwareCheck._autoFlashType = 'custom'
                await performFirmwareUpdate(firmwareCheck)
            } else {
                alert(
                    'Unable to find firmware for this device. Please visit firmware.plode.org'
                )
            }
        } catch (error) {
            console.error('Custom firmware flash failed:', error)
            alert('Firmware update failed. Please try again.')
        }
    }

    const handleMicroPythonFlash = async () => {
        const lastDevice = localStorage.getItem('lastConnectedDevice') || ''
        const lastVersion =
            localStorage.getItem('lastConnectedDeviceVersion') || '1.0'

        const deviceLtsKeyMap = {
            Ace: 'playcomputer',
            Humanoid: 'zing',
            Hexapod: 'crawlee',
            Roboki: 'roboki',
            Klaw: 'klaw',
        }
        const deviceLtsKey =
            deviceLtsKeyMap[lastDevice] || lastDevice.toLowerCase()

        try {
            const ltsResponse = await fetch(
                'https://embedded.plode.org/v2/devices-lts'
            )
            const ltsData = await ltsResponse.json()
            const deviceEntry = ltsData?.devices?.[deviceLtsKey]

            if (!deviceEntry) {
                alert(
                    'MicroPython firmware is not available for this device. Please visit firmware.plode.org'
                )
                return
            }

            let microPythonPath = null
            const versionKeys = Object.keys(deviceEntry)
            for (const vKey of versionKeys) {
                const entry = deviceEntry[vKey]
                if (entry?.variants?.micropython?.path) {
                    if (vKey === lastVersion) {
                        microPythonPath = entry.variants.micropython.path
                        break
                    }
                    if (!microPythonPath) {
                        microPythonPath = entry.variants.micropython.path
                    }
                }
            }

            if (!microPythonPath) {
                alert(
                    'MicroPython firmware is not available for this device version. Please visit firmware.plode.org'
                )
                return
            }

            const firmwareCheck = {
                firmwarePath: microPythonPath,
                deviceName: deviceLtsKey,
                _autoFlashType: 'micropython',
            }

            await performFirmwareUpdate(firmwareCheck)

            sessionStorage.setItem('microPython', 'true')
            localStorage.setItem('microPythonFlashed', 'true')
            localStorage.removeItem('customCodeFlashed')
        } catch (error) {
            console.error('MicroPython flash failed:', error)
            alert('MicroPython firmware update failed. Please try again.')
        }
    }

    // --- Main Device Scan Logic ---
    const scanDevice = async () => {
        sessionStorage.setItem('connectText', 'hello')

        const callbacks = {
            onFirmwareProgress: handleFirmwareProgress,
            onWebAgentRequired: handleWebAgentRequired,
            getLatestSocket: getLatestSocket,
            onAssetUpdateConfirm: handleAssetUpdateConfirm,
            onFirmwareUpdateRequired: handleFirmwareUpdateRequired,
        }

        const res = await connectSerialDeviceInitial(
            { isAutomatic: false },
            props.worker,
            props.socketData,
            callbacks
        )

        if (!res) {
            setShowDialogs((prev) => ({
                ...prev,
                showConnecting: false,
                text: '',
            }))
            return
        }

        if (
            res.noVersionResponse &&
            localStorage.getItem('customCodeFlashed') === 'true'
        ) {
            setShowDialogs((prev) => ({
                ...prev,
                showConnecting: false,
                text: '',
            }))
            props.webSerialConnect({ port: res.port })
            setFirmwareDialogType('custom')
            setShowCustomFirmwareDialog(true)
            return
        }

        if (res.noVersionResponse) {
            setShowDialogs((prev) => ({
                ...prev,
                showConnecting: false,
                text: '',
            }))
            props.webSerialConnect({ port: res.port })
            setFirmwareDialogType('unknown')
            setShowCustomFirmwareDialog(true)
            return
        }

        if (res.firmwareUpdateInProgress) {
            setShowDialogs((prev) => ({
                ...prev,
                showConnecting: false,
                text: '',
            }))
            return
        }

        if (res.firmwareUpdateRequired) {
            setShowDialogs({ showConnecting: false, text: '' })
            return
        }

        setShowDialogs((prev) => ({ ...prev, showConnecting: false, text: '' }))

        const commonDispatchData = {
            isMemoryPresent: res.isMemoryPresent,
            isArmError: res.isArmError,
            is2In1Sensor: res.is2In1Sensor,
            plodeNativeData: {
                ...props.device.plodeNativeData,
                mountPoint: res.mountPoint,
            },
        }

        if (res.isPortOpen) {
            props.deviceMismatch({
                deviceMismatched: {},
                ...commonDispatchData,
            })
            const deviceVersion = sessionStorage.getItem('deviceVersion')
            const connectedDevice = sessionStorage.getItem('connectedDevice')

            props.deviceDetails({ connectedDevice, deviceVersion })
            props.webSerialConnect({ port: res.port })

            localStorage.setItem('lastConnectedDevice', connectedDevice)
            if (!res.isMicroPython) {
                localStorage.setItem(
                    'lastConnectedDeviceVersion',
                    deviceVersion?.split('.')?.slice(0, 2)?.join('.') || '1.0'
                )
            }
            sessionStorage.setItem('manualConnection', false)

            if (res.isMicroPython) {
                setFirmwareDialogType('micropython')
                setShowCustomFirmwareDialog(true)
                return
            }

            setVariDevice(true)
        } else {
            props.deviceMismatch({
                deviceMismatched: res.allowedDeviceObj,
                isMemoryPresent: res.isMemoryPresent,
                isArmError: res.isArmError,
                is2In1Sensor: res.is2In1Sensor,
                plodeNativeData: {
                    ...props.device.plodeNativeData,
                    mountPoint: res.mountPoint,
                },
            })
            props.webSerialConnect({ port: res.port })
            setIsDeviceMismatch(true)
        }
    }

    const handleTextChange = useCallback(
        (e) => {
            const data = e.detail
            if (
                data === 'unable to connect the device' &&
                localStorage.getItem('customCodeFlashed') === 'true'
            ) {
                return
            }
            if (!isDeviceMismatchRef.current)
                setShowDialogs({
                    ...showDialogs,
                    showConnecting: true,
                    text: data,
                })
            else
                setShowDialogs({
                    ...showDialogs,
                    showConnecting: false,
                    text: '',
                })
        },
        [isDeviceMismatch]
    )

    useEffect(() => {
        if (!props.isConnected) {
            props.deviceMismatch({ deviceMismatched: {} })
        }
    }, [props.isConnected])

    useEffect(() => {
        if (
            props.device.deviceMismatched &&
            Object.keys(props.device.deviceMismatched).length > 0
        )
            setIsDeviceMismatch(true)
        else setIsDeviceMismatch(false)
    }, [props.device.deviceMismatched])

    useEffect(() => {
        document.addEventListener('custom', handleTextChange)
        return () => document.removeEventListener('custom', handleTextChange)
    }, [])

    const handleDialogModalClose = () => {
        setShowDialogs({ ...showDialogs, showDialog: false })
    }

    const handleDialogModalOpen = () => {
        setSlideDirection(false)
        sessionStorage.setItem('slideDirection', false)
        setShowDialogs({ ...showDialogs, showDialog: true })
    }

    const optionsToSelect = [
        {
            text: 'YES',
            do: async () => {
                let allowedDevice =
                    sessionStorage.getItem('allowedDevice') || 'Ace'
                const connectedVersion = sessionStorage.getItem('deviceVersion')
                sessionStorage.setItem(
                    'connectedDevice',
                    allowedDevice?.includes('Ace') ? 'Ace' : allowedDevice
                )
                const pickedVariant = sessionStorage.getItem(
                    'allowedPeeCeeVariant'
                )
                if (pickedVariant === 'ted1' || pickedVariant === 'ted2') {
                    sessionStorage.setItem(
                        'peeCeeConfVersion',
                        pickedVariant.slice(-1)
                    )
                } else {
                    sessionStorage.removeItem('peeCeeConfVersion')
                }
                let { latestVersion } = await fetchVersion(
                    getVersionArguments[allowedDevice]
                        ? getVersionArguments[allowedDevice].deviceName
                        : 'Playcomputer',
                    getVersionSeries(allowedDevice, connectedVersion)
                )
                sessionStorage.setItem(
                    'deviceVersion',
                    latestVersion.replace(/\.0$/, '')
                )
                history.push('/Selection')
            },
        },
        { text: 'NO', do: handleDialogModalClose },
    ]

    useEffect(() => {
        let assetsToBeCached = [
            renderImage('Connect'),
            renderImage('ZingConnect'),
        ]
        cacheAssets(assetsToBeCached)
    }, [])

    const handleDevice = async (res) => {
        if (res == 'yes') {
            let mismatchedDevice = props.device.deviceMismatched
            // The variant-mismatch popup carries a different shape
            // (connectedDevice/detectedVersion) than the generic device
            // mismatch popup (id/version) — normalize to one pair here.
            const isVariantAcceptance = !!mismatchedDevice.variantMismatch
            const deviceId =
                mismatchedDevice.id || mismatchedDevice.connectedDevice
            const deviceVersion =
                mismatchedDevice.version || mismatchedDevice.detectedVersion

            sessionStorage.setItem('connectedDevice', deviceId)
            sessionStorage.setItem('deviceVersion', deviceVersion)
            if (props.isConnected)
                sessionStorage.setItem('isDeviceConnected', true)
            sessionStorage.setItem('manualConnection', false)
            props.deviceDetails({
                connectedDevice: deviceId,
                deviceVersion: deviceVersion,
            })
            setIsDeviceMismatch(false)
            setVariDevice(true)
            props.deviceMismatch({ deviceMismatched: {} })

            // Only after the device-type mismatch is accepted do we check
            // whether the connected PeeCee's Ted1/Ted2 variant matches what
            // was selected — that popup must show before the firmware check.
            // Skip this when the user just accepted the variant popup
            // itself, otherwise it would immediately reopen.
            if (!isVariantAcceptance) {
                const allowedPeeCeeVariant = sessionStorage.getItem(
                    'allowedPeeCeeVariant'
                )
                const peeCeeConfVersion = sessionStorage.getItem(
                    'peeCeeConfVersion'
                )
                if (
                    deviceId === 'Ace' &&
                    allowedPeeCeeVariant &&
                    peeCeeConfVersion
                ) {
                    const detectedVariant =
                        peeCeeConfVersion === '2' ? 'ted2' : 'ted1'
                    if (detectedVariant !== allowedPeeCeeVariant) {
                        props.deviceMismatch({
                            deviceMismatched: {
                                variantMismatch: true,
                                selected: getPeeCeeVariantLabel(
                                    allowedPeeCeeVariant
                                ),
                                detected: getPeeCeeVariantLabel(
                                    detectedVariant
                                ),
                                detectedVariantKey: detectedVariant,
                                connectedDevice: deviceId,
                                detectedVersion: deviceVersion,
                            },
                        })
                        setIsDeviceMismatch(true)
                        return
                    }
                }
            }

            // Only after both mismatch checks pass do we check whether the
            // now-connected device's firmware is still supported.
            const minFirmware = getRequiredFirmwareMin(deviceId, deviceVersion)

            if (minFirmware) {
                const minCheck = await checkFirmwareVersion(
                    getVersionObjNameKey(deviceId),
                    deviceVersion,
                    minFirmware.split('.').slice(0, 2).join('.')
                )
                const firmwareCheck = {
                    ...minCheck,
                    updateAvailable: true,
                    mandatory: true,
                    latestVersion: minCheck.latestVersion || minFirmware,
                }
                props.showFirmwareUpdateDialog({
                    currentVersion: firmwareCheck.currentVersion,
                    latestVersion: firmwareCheck.latestVersion,
                    deviceName: firmwareCheck.deviceName,
                    firmwareCheck,
                })
            }
        } else {
            props.deviceMismatch({ deviceMismatched: {} })
            setIsDeviceMismatch(false)
            sessionStorage.removeItem('allowedDevice')
            history.push(props.selectionBackRoute)
        }
        sessionStorage.removeItem('allowedDevice')
        sessionStorage.removeItem('allowedPeeCeeVariant')
    }

    const getDeviceName = (device) => getBrandDeviceName(device)

    const mismatchedDeviceInfo = props.device.deviceMismatched
    const isVariantMismatch = !!mismatchedDeviceInfo?.variantMismatch
    const mismatchSelectedLabel = isVariantMismatch
        ? mismatchedDeviceInfo?.selected
        : getDeviceName(mismatchedDeviceInfo?.selected)
    const mismatchConnectedLabel = isVariantMismatch
        ? mismatchedDeviceInfo?.detected
        : mismatchedDeviceInfo?.peeCeeVariant
          ? getPeeCeeVariantLabel(mismatchedDeviceInfo.peeCeeVariant)
          : getDeviceName(mismatchedDeviceInfo?.id)

    return (
        <>
            <DeviceMismatchDialog
                isOpen={isDeviceMismatch && !showDialogs.showConnecting}
                selectedLabel={mismatchSelectedLabel}
                connectedLabel={mismatchConnectedLabel}
                onAccept={() => handleDevice('yes')}
                onClose={() => {
                    setIsDeviceMismatch(false)
                    props.deviceMismatch({ deviceMismatched: {} })
                    if (isVariantMismatch) {
                        sessionStorage.removeItem('allowedDevice')
                        sessionStorage.removeItem('allowedPeeCeeVariant')
                        history.push(props.selectionBackRoute)
                    }
                }}
            />
            <DialogModal
                show={showDialogs.showDialog}
                text="Do you want to continue without your device being connected ?"
                showCloseBtn={false}
                handleDialogModalClose={handleDialogModalClose}
                optionsToSelect={optionsToSelect}
            />
            <DialogModal
                connection={
                    showDialogs.showConnecting &&
                    !showDialogs.showBootModeDialog
                }
                text={showDialogs.text}
                progress={showDialogs.progress}
                optionsToSelect={
                    showDialogs.reconnectOptions || [
                        {
                            text: 'OK',
                            do: () => {
                                setShowDialogs({
                                    ...showDialogs,
                                    showConnecting: false,
                                    text: '',
                                    progress: null,
                                })
                                history.push(props.selectionBackRoute)
                            },
                        },
                    ]
                }
            />
            <DialogModal
                mismatchShow={showDialogs.showBootModeDialog}
                text={showDialogs.text}
                showCloseBtn={false}
                optionsToSelect={showDialogs.bootModeOptions || []}
            />
            <DialogModal
                mismatchShow={showDialogs.showReconnectDialog}
                text={showDialogs.text}
                showCloseBtn={false}
                preventBackdropClose={true}
                optionsToSelect={showDialogs.reconnectOptions || []}
            />

            <div className={DeviceSelectStyle.Connect_Device}>
                <div className={DeviceSelectStyle.Connect_Header}>
                    {isHelp ? (
                        <div>
                            <img
                                className={DeviceSelectStyle.back_btn}
                                style={{ zIndex: '-1' }}
                                src={renderImage('backBtn')}
                                onClick={goBackUrl}
                            ></img>{' '}
                        </div>
                    ) : (
                        <div>
                            <img
                                className={DeviceSelectStyle.back_btn}
                                style={{ zIndex: '1000' }}
                                src={renderImage('backBtn')}
                                onClick={goBackUrl}
                            ></img>{' '}
                        </div>
                    )}

                    <div>
                        {isHelp == false ? (
                            <div className="header_button">
                                <img
                                    className={DeviceSelectStyle.helpBtn}
                                    src={renderImage('helpBtnInActive')}
                                    onClick={handleHelpBtn}
                                ></img>
                                <span className="tooltiptext">
                                    {' '}
                                    <p>Help</p>
                                </span>
                            </div>
                        ) : (
                            <div
                                style={{
                                    height: '100vh',
                                    width: '100vw',
                                    background: '#fff',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%,-50%)',
                                    zIndex: '1000',
                                    position: 'absolute',
                                }}
                            >
                                <div
                                    style={{
                                        transform: 'translate(-50%,-50%)',
                                        top: '47%',
                                        left: '50%',
                                        zIndex: '10',
                                        position: 'absolute',
                                        width: '65vw',
                                    }}
                                >
                                    <div>
                                        <img
                                            src={
                                                sessionStorage.getItem(
                                                    'connectedDevice'
                                                ) === 'Humanoid'
                                                    ? renderImage('ZingConnect')
                                                    : renderImage('Connect')
                                            }
                                            style={{
                                                width: '100%',
                                            }}
                                        ></img>
                                    </div>
                                    <div className={DeviceSelectStyle.instr}>
                                        <p
                                            className={
                                                DeviceSelectStyle.instr_P
                                            }
                                        >
                                            {' '}
                                            Help Button will explain all the
                                            features and functionality of the
                                            entire app for each screen{' '}
                                        </p>
                                    </div>
                                    <div className={DeviceSelectStyle.instr2}>
                                        <p
                                            className={
                                                DeviceSelectStyle.instr2_P
                                            }
                                        >
                                            Manual scan will list all the
                                            {getAppName()} devices if multiple
                                            devices are ON
                                        </p>
                                    </div>
                                    <div className={DeviceSelectStyle.instr3}>
                                        <p
                                            className={
                                                DeviceSelectStyle.instr3_P
                                            }
                                        >
                                            Skip button will skip the scanning
                                            and connecting over bluetooth to
                                            {getAppName()}.If you skip you will
                                            not be able to send data to
                                            {getAppName()}.{' '}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                        {isHelp ? (
                            <div className="web_button">
                                <img
                                    className={DeviceSelectStyle.Cross}
                                    src={renderImage('clos')}
                                    onClick={handleHelpBtn}
                                ></img>
                                <span className="tooltiptext">
                                    {' '}
                                    <p>
                                        {' '}
                                        Device <br />
                                        connectivity
                                    </p>
                                </span>
                            </div>
                        ) : null}
                        {/* <img className="DeviceSelectStyle.Help_btn" src={help}></img> */}
                    </div>
                </div>

                <div
                    className={`${
                        slideDirection === 'true' ? 'slide-right' : ''
                    }`}
                    style={{ position: 'relative' }}
                >
                    <div className={DeviceSelectStyle.Connect_div}>
                        <img
                            className={DeviceSelectStyle.Pc_Image}
                            src={renderImage('PC_New')}
                        ></img>
                        <img
                            className={DeviceSelectStyle.Computer_Img}
                            src={renderImage('Computer')}
                        ></img>
                    </div>
                </div>

                <div></div>
                <div
                    className={`${
                        slideDirection === 'true' ? 'slide-right' : ''
                    }`}
                    style={{ position: 'relative' }}
                >
                    {' '}
                    <div>
                        <img
                            className={DeviceSelectStyle.Scan_Button}
                            src={renderImage('reconnectSvg')}
                            onClick={() => {
                                scanDevice()
                                // connect();
                            }}
                        ></img>

                        {/* <Link to="/Connect"> */}
                        <h4
                            className={DeviceSelectStyle.Scan_txt}
                            onClick={scanDevice}
                            // onClick={gobackUrl}
                        >
                            {languageWords[props.languageName]?.ScanDevice ||
                                'Scan Device'}
                        </h4>
                    </div>
                </div>

                <div
                    className={DeviceSelectStyle.Connect_Footer}
                    style={isHelp ? { zIndex: '-1' } : null}
                >
                    <div>
                        <p className={DeviceSelectStyle.Instructions}>
                            Connect the device to your system using the USB
                            cable provided
                        </p>
                    </div>
                    <div>
                        <p className={DeviceSelectStyle.version}>
                            v{packageJson.version}
                        </p>
                    </div>
                    {/* <Link to="/conformation"> */}
                    <div>
                        <img
                            className={DeviceSelectStyle.Skip_Button}
                            src={renderImage('skip')}
                            onClick={handleDialogModalOpen}
                        ></img>
                    </div>
                    {/* </Link> */}
                </div>
            </div>

            <FirmwareAssetsUpdateModal
                isOpen={props.firmwareAssetsUpdate?.isOpen}
                stage={props.firmwareAssetsUpdate?.stage}
                message={props.firmwareAssetsUpdate?.message}
                percent={props.firmwareAssetsUpdate?.percent}
                onClose={handleCloseModal}
            />
            <WebAgentDialog
                isOpen={props.webAgentDialog?.isOpen}
                onInstall={handleWebAgentInstall}
                onStop={handleWebAgentStop}
                onCancel={handleWebAgentCancel}
                isInstalling={props.webAgentDialog?.isInstalling}
                isAgentConnected={props.socketData?.isAgentConnected}
            />
            <AssetUpdateDialog
                isOpen={props.assetUpdateDialog?.isOpen}
                onInstall={handleAssetUpdateInstall}
                onSkip={handleAssetUpdateSkip}
            />
            <FirmwareUpdateDialog
                isOpen={props.firmwareUpdateDialog?.isOpen}
                currentVersion={props.firmwareUpdateDialog?.currentVersion}
                latestVersion={props.firmwareUpdateDialog?.latestVersion}
                deviceName={props.firmwareUpdateDialog?.deviceName}
                mandatory={props.firmwareUpdateDialog?.firmwareCheck?.mandatory}
                onUpdate={handleFirmwareUpdate}
                onSkip={handleFirmwareUpdateSkip}
                onClose={handleFirmwareUpdateClose}
            />
            <DialogModal
                show={showCustomFirmwareDialog}
                preventBackdropClose={true}
                text={
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '0.5rem',
                        }}
                    >
                        <p style={{ fontSize: '2.2vh', fontWeight: 'bold' }}>
                            {firmwareDialogType === 'micropython'
                                ? 'MicroPython Firmware Detected'
                                : firmwareDialogType === 'unknown'
                                  ? 'Unable to Identify Device'
                                  : 'Custom Firmware Detected'}
                        </p>
                        <p style={{ fontSize: '1.8vh', textAlign: 'center' }}>
                            {firmwareDialogType === 'micropython'
                                ? 'This device is running MicroPython firmware. Some features may not work. You can flash the original firmware or continue with limited features.'
                                : firmwareDialogType === 'unknown'
                                  ? 'The connected device did not respond. This could happen if the device is in boot mode, has custom firmware, or is not a Plode device.'
                                  : 'It looks like you flashed custom firmware on this device. Would you like to continue or flash the original firmware?'}
                        </p>
                        {(firmwareDialogType === 'micropython' ||
                            firmwareDialogType === 'unknown') && (
                            <div
                                style={{
                                    fontSize: '1.6vh',
                                    textAlign: 'center',
                                    background: '#FFF3E0',
                                    borderRadius: '8px',
                                    padding: '0.5rem 0.8rem',
                                    marginTop: '0.3rem',
                                    color: '#E65100',
                                    lineHeight: '1.5',
                                }}
                            >
                                {firmwareDialogType === 'unknown' ? (
                                    <>
                                        <strong>If in boot mode:</strong>{' '}
                                        Disconnect the device and reconnect
                                        without holding the BOOT button, then
                                        scan again.
                                    </>
                                ) : (
                                    <>
                                        <strong>To flash firmware:</strong>{' '}
                                        Disconnect the device, hold the{' '}
                                        <strong>BOOT</strong> button, reconnect
                                        via USB, then release the button. After
                                        that, click "Flash Firmware" and select
                                        the device.
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() =>
                    setShowCustomFirmwareDialog(false)
                }
                optionsToSelect={
                    firmwareDialogType === 'micropython'
                        ? [
                              {
                                  text: 'Continue',
                                  do: handleCustomFirmwareContinue,
                              },
                              {
                                  text: 'Flash Firmware',
                                  do: handleCustomFirmwareFlash,
                              },
                              {
                                  text: 'Download from Website',
                                  do: () => {
                                      setShowCustomFirmwareDialog(false)
                                      window.open(
                                          'https://firmware.plode.org/',
                                          '_blank'
                                      )
                                  },
                              },
                          ]
                        : firmwareDialogType === 'unknown'
                          ? [
                                {
                                    text: 'Continue',
                                    do: handleCustomFirmwareContinue,
                                },
                                {
                                    text: 'Flash Original Firmware',
                                    do: handleCustomFirmwareFlash,
                                },
                            ]
                          : [
                                {
                                    text: 'Continue',
                                    do: handleCustomFirmwareContinue,
                                },
                                {
                                    text: 'Flash Firmware',
                                    do: handleCustomFirmwareFlash,
                                },
                            ]
                }
            />
            <DialogModal
                show={pendingAutoFlash !== null}
                preventBackdropClose={true}
                text={
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '0.5rem',
                        }}
                    >
                        <p style={{ fontSize: '2.2vh', fontWeight: 'bold' }}>
                            {pendingAutoFlash === 'micropython'
                                ? 'Flash MicroPython Firmware'
                                : 'Flash Original Firmware'}
                        </p>
                        <p style={{ fontSize: '1.8vh', textAlign: 'center' }}>
                            {pendingAutoFlash === 'micropython'
                                ? 'Click the button below to select your device and start flashing MicroPython firmware.'
                                : 'Click the button below to select your device and start flashing the original firmware.'}
                        </p>
                        {pendingAutoFlash === 'micropython' && (
                            <div
                                style={{
                                    fontSize: '1.6vh',
                                    textAlign: 'center',
                                    background: '#FFF3E0',
                                    borderRadius: '8px',
                                    padding: '0.5rem 0.8rem',
                                    marginTop: '0.3rem',
                                    color: '#E65100',
                                    lineHeight: '1.5',
                                }}
                            >
                                <strong>To flash firmware:</strong> Disconnect
                                the device, hold the <strong>BOOT</strong>{' '}
                                button, reconnect via USB, then release the
                                button. After that, click "Start Flashing" and
                                select the device.
                            </div>
                        )}
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setPendingAutoFlash(null)}
                optionsToSelect={[
                    {
                        text: 'Start Flashing',
                        do: () => {
                            const flashType = pendingAutoFlash
                            setPendingAutoFlash(null)
                            if (flashType === 'micropython') {
                                handleMicroPythonFlash()
                            } else {
                                handleCustomFirmwareFlash()
                            }
                        },
                    },
                    {
                        text: 'Cancel',
                        do: () => setPendingAutoFlash(null),
                    },
                ]}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    webserialPort: state.webSerial,
    worker: state.worker,
    device: state.device,
    deviceMismatch: state.deviceMismatch,
    isConnected: state.webSerial.isConnected,
    languageName: state.device.language,
    socketData: state.socketData,
    selectionBackRoute: state.navigation.selectionBackRoute,
    firmwareAssetsUpdate: state.firmwareAssetsUpdate,
    webAgentDialog: state.webAgentDialog,
    assetUpdateDialog: state.assetUpdateDialog,
    firmwareUpdateDialog: state.firmwareUpdateDialog,
})

const mapDispatchToProps = (dispatch) => ({
    webSerialConnect: (data) => dispatch(webSerialConnect(data)),
    webSerialDisconnect: () => dispatch(webSerialDisconnect()),
    showModal: (data) => dispatch(showModal(data)),
    deviceDetails: (data) => dispatch(deviceDetails(data)),
    deviceMismatch: (data) => dispatch(deviceMismatch(data)),
    setFirmwareAssetsUpdateProgress: (data) =>
        dispatch({ type: 'FIRMWARE_ASSETS_UPDATE_PROGRESS', payload: data }),
    showWebAgentDialog: () => dispatch({ type: 'SHOW_WEB_AGENT_DIALOG' }),
    hideWebAgentDialog: () => dispatch({ type: 'HIDE_WEB_AGENT_DIALOG' }),
    setWebAgentInstalling: () => dispatch({ type: 'SET_WEB_AGENT_INSTALLING' }),
    showAssetUpdateDialog: () => dispatch({ type: 'SHOW_ASSET_UPDATE_DIALOG' }),
    hideAssetUpdateDialog: () => dispatch({ type: 'HIDE_ASSET_UPDATE_DIALOG' }),
    setUserIgnoredWebAgent: () => dispatch({ type: 'USER_IGNORED_WEB_AGENT' }),
    setUserIgnoredAssetUpdate: () =>
        dispatch({ type: 'USER_IGNORED_ASSET_UPDATE' }),
    showFirmwareUpdateDialog: (payload) =>
        dispatch({ type: 'SHOW_FIRMWARE_UPDATE_DIALOG', payload }),
    hideFirmwareUpdateDialog: () =>
        dispatch({ type: 'HIDE_FIRMWARE_UPDATE_DIALOG' }),
    clearIgnoredFirmware: () => dispatch({ type: 'CLEAR_IGNORED_FIRMWARE' }),
    setUserIgnoredFirmwareUpdate: (firmwareKey) =>
        dispatch({
            type: 'USER_IGNORED_FIRMWARE_UPDATE',
            payload: firmwareKey,
        }),
})

export default connect(mapStateToProps, mapDispatchToProps)(DeviceSelect)
